<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <nb-card class="form">
    <nb-card-header
      ><h4>{{ "dialogs.inviteUser.title" | translate }}</h4></nb-card-header
    >
    <nb-card-body>
      <div class="form-group row" style="padding-top: 20px">
        <label for="name" class="label col-sm-3 col-form-label">
          Trial End Date
        </label>
        <div class="col-sm-9">
          <input
            nbInput
            placeholder="Pick Date"
            [nbDatepicker]="dateTimePicker"
            fullWidth=""
            formControlName="end_date"
            [status]="showInputError('end_date') ? 'danger' : 'basic'"
          />
          <nb-datepicker
            format="yyyy-MM-dd"
            #dateTimePicker
            [filter]="filterFn"
          ></nb-datepicker>
        </div>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <button
        type="button"
        nbButton
        status="danger"
        outline
        (click)="dialogRef.close()"
      >
        {{ "buttons.cancel" | translate }}
      </button>
      <button type="submit" nbButton status="primary">Extend Trial</button>
    </nb-card-footer>
  </nb-card>
</form>
